import { h, render } from "preact"
import { qsa } from "../utils/dom"
import { Issuebox } from "./issuebox"

export const initIssuebox = () => {
  qsa(".issuebox-app").forEach((box) => {
    render(<Issuebox endpointUrl={box.dataset.endpoint} />, box)
  })
}
